export const ENV = 'prod';
export const GENERIC_URL = {
  local: {
    api: 'http://localhost:6699/',
    oldapi: 'https://api-staging.pgslot-api.com/',
    socket: 'https://sk-lobby-staging.ambpoker.com/',
    ambslot_result: 'https://web-api-staging.ambslot-api.com/result/pg',
    ambslot_result_mh: 'https://staging.ambslot-api.com/report/result',
    evo_result: 'https://api-staging.pgslot-api.com/report/winlose/result',
    ambslot_backend: 'https://staging.ambslot-api.com/report/round/detail',
  },
  dev: {
    api: 'https://web-api-sit.pgslot-api.com/',
    oldapi: 'https://api-staging.pgslot-api.com/',
    socket: 'https://skt-staging.pgslot-api.com/',
    ambslot_result: 'https://web-api-staging.ambslot-api.com/result/pg',
    ambslot_result_mh: 'https://staging.ambslot-api.com/report/result',
    evo_result: 'https://api-staging.pgslot-api.com/report/winlose/result',
    ambslot_backend: 'https://staging.ambslot-api.com/report/round/detail',
  },
  uat: {
    api: 'https://web-api-uat.pgslot-api.com/',
    oldapi: 'https://api-uat.pgslot-api.com/',
    socket: 'https://skt-uat.pgslot-api.com/',
    ambslot_result: 'https://web-api-uat.ambslot-api.com/result/pg',
    ambslot_result_mh: 'https://uat.ambslot-api.com/report/result',
    evo_result: 'https://api-uat.pgslot-api.com/report/winlose/result',
    ambslot_backend: 'https://uat.ambslot-api.com/report/round/detail',
  },
  prod: {
    api: 'https://pgslot-web-api-prod.pgslot-api.com/',
    oldapi: 'https://api-prod.pgslot-api.com/',
    report: 'https://report-prod.pgslot-api.com/',
    socket: 'wss://skt-prod.pgslot-api.com',
    ambslot_result: 'https://web-api-prod.ambslot-api.com/result/pg',
    ambslot_result_mh: 'https://prod.ambslot-api.com/report/result',
    evo_result: 'https://api-prod.pgslot-api.com/report/winlose/result',
    ambslot_backend: 'https://https://prod.ambslot-api.com/report/round/detail',
  },
};

export const BASE_URL = GENERIC_URL[ENV].api;
export const SOCKET_URL = GENERIC_URL[ENV].socket;
export const BASE_URL_OLD = GENERIC_URL[ENV].oldapi;
export const AMBSLOT_RESULT = GENERIC_URL[ENV].ambslot_result;
export const AMBSLOT_RESULT_MH = GENERIC_URL[ENV].ambslot_result_mh;
export const EVO_RESULT = GENERIC_URL[ENV].evo_result;
export const BACKEND_RESULT = GENERIC_URL[ENV].ambslot_backend;
export const M_GET = 'GET';
export const M_POST = 'POST';
export const M_PUT = 'PUT';
export const M_DELETE = 'DELETE';
export const PG_SECRET = 'a86f63f8722128b5c5c9a05914f70138';
export const PUBLIC_PG_KEY = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzv7aYVAm5GPRf4r58T+quJdDzgbWwjB5ou7VAzeHNvT5vtUOztJunAQbQBTDvTZOTWZYdXTF0Tu18vY3ZMCuw0zRjjOlketMbpvP57OGhAmbL3Ont2A5fzmcc7RbiRgOOJN5FnjWMitFptUjx55Lbw84/m00Z+SdoX6A2NQDmqQIDAQAB-----END PUBLIC KEY-----';

// Auth
export const LOGIN = 'auth/login/agent';
export const REFRESH = 'auth/refresh';
export const FIND_SUBPASS = 'auth/sub-password/find';
export const CREATE_SUBPASS = 'auth/sub-password/create';
export const VER_SUBPASS = 'auth/sub-password/verify';

// User
export const USERS_CREATE_V2 = 'user/register/v2';
export const USERS = 'user/list';
export const USERS_HISTORY = 'user/history';
export const GET_PROFILE = 'user/profile/get';
export const UPDATE_PROFILE = 'user/profile/update';
export const UPDATE_COMMISSION = 'user/commission';
export const USERS_GENERATE = 'user/generate';
export const USERS_BALANCE = 'user/balance';
export const USERS_SUBAGENT = 'user/subagent/list';
export const GET_USERS_DOWNLINE = 'user/search';
export const RESET_PASSWORD = 'user/password/reset';

// User [BE]
export const USERS_ACTIVATE = 'user/activate';

// Report
export const WINLOSE_REPORT_V2 = 'report/winlose/simple/v2';
export const WINLOSE_REPORT_LOGS = 'report/winlose/simple/logs';
export const GET_GAMES = 'report/winlose/getGames';
export const PROVIDER_REPORT = 'report/winlose/provider';
export const PROVIDER_TYPE_REPORT = 'report/winlose/provider/type';
export const REPORT_DASHBOARD = 'report/winlose/dashboard';
export const INVOICE_REPORT = 'report/winlose/invoice';
export const GENERATE_EXCEL_INVOICE = 'report/winlose/invoice/excel';
export const WINLOSE_RANGE_DATE_REPORT_LOGS = 'report/winlose/dayLogs';
export const WINLOSE_REPORT_NEW_V2 = 'new-report/winlose/simple/v2';
export const WINLOSE_DOWNLOAD_REPORT_CSV = 'new-report/financial/csv';

// Result
// - Normal
export const WINLOSE_RESULT = 'report/winlose/result';
// - Ampoker
export const GET_RESULT_AMBPOKER = 'ambpoker/report';
// - DS
export const GET_RESULT_ALL_DS = 'report/winlose/result/ds';

// New-Report
export const NEW_WINLOSE_REPORT = 'new-report/winlose/simple';
export const NEW_WINLOSE_REPORT_TOGGLE = 'new-report/winlose/simple/toggle';
export const ALL_WINLOSE_REPORT = 'new-report/winlose/simple/all';

// Player [BE]
export const PLAYER_ONLINE = 'player/online';

// Dashboard
export const DASHBOARD = 'dashboard';

// Key
export const GET_TRANSFER_KEY = 'key/fetch';

// Seamless Key
export const GET_SEAMLESS_KEY = 'seamlessKey/fetch';
export const UPDATE_SEAMLESS_KEY = 'seamlessKey/edit';
export const GET_URL_SEAMLESS = 'seamlessKey/url';

// Seamless
export const FETCH_RESULT_AMBSLOT_ARCADE = 'seamless/result/arcade';

// Suggestion
export const SUGGESTION_GET_REPORT = 'suggestion/report';
export const SUGGESTION_SHEET = 'suggestion/sheet';
export const SUGGESTION_GET_TOPIC = 'suggestion/fetch';

// Announcement
export const ANNOUNCEMENT_LIST = 'announcement/list';
export const ANNOUNCEMENT_CREATE = 'announcement/create';
export const ANNOUNCEMENT_DELETE = 'announcement/delete';
export const ANNOUNCEMENT_UPDATE = 'announcement/update';

// Agent Banner
export const AGENT_BANNER_CREATE = 'agentbanner/create';
export const AGENT_BANNER_UPDATE = 'agentbanner/update';
export const AGENT_BANNER_LIST = 'agentbanner/list';
export const AGENT_BANNER_DELETE = 'agentbanner/delete';

// User Permission
export const UPDATE_PERMISSION = 'user-permission/update';

// Prefix
export const CHECK_PREFIX = 'prefix';

// Sub Password
export const FIND_USER_SUBPASS = 'subpassword/find-user';
export const RESET_SUBPASS = 'subpassword/reset';

// Social
export const SOCIAL_FETCH = 'social/fetch';
export const SOCIAL_EDIT = 'social/edit';

// Bank Account
export const BANKACCOUNT_LIST = 'bank-account/list';
export const BANKACCOUNT_CREATE = 'bank-account/create';
export const BANKACCOUNT_UPDATE = 'bank-account/update';
export const BANKACCOUNT_DELETE = 'bank-account/delete';
export const BANK_NAME_LIST = 'bank-account/bank/list';

// Document
export const DOCUMENT_DOWNLOAD = 'document/download';
export const DOCUMENT_FETCH = 'document/fetch';
export const DOCUMENT_CREATE = 'document/create';
export const DOCUMENT_UPDATE = 'document/create';
export const DOCUMENT_DELETE = 'document/delete';

// Invoice
export const GENERATE_PDF_INVOICE = 'invoice/exportpdf';

// Point
export const FETCH_POINT = 'point/report';
export const FETCH_POINT_LOG = 'point/report/log';

// Transfer
export const TRANSFER = 'transfer/credit/refill';
export const GET_STATEMENT = 'transfer/statement';
export const GET_STATEMENT_DETAIL = 'transfer/statement/detail';

// Transfer [BE]
export const WITHDRAW = 'transfer/credit/deduct';

// Admin
export const FETCH_RESET_SUBPASS_LOG = 'admin/sub-password/logs';
export const FETCH_EVOPLAY_SESSIONS = 'admin/evoplay/find';
export const USER_SEAMLESS_PROBLEM_ADD = 'admin/user-seamless/add';
export const USER_SEAMLESS_PROBLEM_FETCH = 'admin/user-seamless/fetch';
export const USER_SEAMLESS_PROBLEM_REMOVE = 'admin/user-seamless/remove';
export const USER_SEAMLESS_PROBLEM_SEARCH = 'admin/user-seamless/search';
export const RESET_PASSWORD_LOG = 'admin/reset-password-log';
export const FETCH_MAINTENANCE_LIST = 'admin/maintenance/list';
export const GAME_MAINTENANCE = 'admin/game/maintenance';
export const FETCH_UPDATE_COMMISSION_LOG = 'admin/commission-logs';
export const FETCH_WEB_DATA = 'landing-page/fetch';
export const CREATE_WEB_DATA = 'admin/webManagement/create';
export const UPLOAD_IMAGE_WEB_DATA = 'admin/upload-image';
export const DELETE_IMAGE_WEB_DATA = 'admin/delete-image';
export const UPDATE_WEB_DATA = 'admin/webManagement/update';
export const DELETE_WEB_DATA = 'admin/webManagement/delete';

// Promotion [BE]
export const PROMOTION_FETCH = 'promotion/fetch';
export const PROMOTION_ADD = 'promotion/add';
export const PROMOTION_EDIT = 'promotion/edit';
export const PROMOTION_DELETE = 'promotion/delete';

// Angpow [BE]
export const FLAG_FETCH = 'angpow/manage/newLobby/fetch';
export const FLAG_EDIT = 'angpow/manage/newLobby/edit';
export const LEGENOFDOLLY_REPORT = 'angpow/legendofdolly/report';

// Maintenance [BE]
export const MAINTENANCE_ALL = 'maintenance/switch';
export const MAINTENANCE_PARTNER = 'maintenance/switchGame';

// Games Management
export const FETCH_GAME_KEY = 'game/fetchindex';
export const FETCH_GAME_SORT = 'game/fetchsort';
export const FETCH_GAME_TAG = 'game/fetchtagall';
export const EDIT_GAME_SORT = 'game/editsort';
export const EDIT_GAME_TAG = 'game/edittag';

// Activity
export const FETCH_ACTIVITY_LOG = 'activity/fetchlog';
export const FETCH_ACCESS_LOG = 'user/accesslog';

// Angpow
export const FETCH_LOTTO = 'angpow/lotto';

// CryptoAccount
export const CRYPTO_FETCH = 'cryptoaccount/fetch';
export const CRYPTO_CREATE = 'cryptoaccount/create';
export const CRYPTO_UPDATE = 'cryptoaccount/update';
export const CRYPTO_DELETE = 'cryptoaccount/DELETE';

// Marketing Report
export const FETCH_MARKETING_REPORT = 'marketing-report/';

// Support
export const SUPPORT_GET_USER = 'support/get/user';
export const SUPPORT_EDIT_USER = 'support/edit/user';
export const SUPPORT_GET_BET = 'support/get/bettransaction';
export const SUPPORT_GET_BET_FAILED = 'support/get/betTransactionFailed';

// Domain pool
export const DOMAIN_POOL_LIST = 'domain-pool/list';
export const DOMAIN_POOL_ADD = 'domain-pool/add';
export const DOMAIN_POOL_UPDATE = 'domain-pool/update';
